

module.exports = __webpack_require__.stylable.create(
    "emptystate2405882187",
    {"classes":{"root":"emptystate2405882187__root","mobile":"emptystate2405882187__mobile"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "emptystate2405882187",
    null
);
